import { render } from "./CompleteAlert.vue?vue&type=template&id=0aae4e7e"
import script from "./CompleteAlert.vue?vue&type=script&lang=js"
export * from "./CompleteAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/v2/Modal/CompleteAlert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0aae4e7e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0aae4e7e', __exports__)) {
    api.reload('0aae4e7e', __exports__)
  }
  
  module.hot.accept("./CompleteAlert.vue?vue&type=template&id=0aae4e7e", () => {
    api.rerender('0aae4e7e', render)
  })

}


export default __exports__